import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }

  findUser(keyword?: string, page?: number, limit?: number) {
    const payload: any = { keyword, page, limit };
    return this.http.post<any>('api_endpoint' + '/user/admin-find', payload);
  }

  findUserV2(keyword?: string, page?: number, limit?: number) {
    const payload: any = { keyword, page, limit };
    return this.http.post<any>('api_endpoint' + '/user/v2/admin-find', payload);
  }

  getOrganisations() {
    return this.http.post<any>('api_endpoint' + '/organisation/index', { }).pipe(
      map(res => res.data)
    );
  }

  deleteUser(_userId) {
    return this.http.post<any>('api_endpoint' + '/user/delete-account-by-admin', { _userId });
  }
}
